import { lazy, Suspense } from 'react';

import { LoadingScreen } from '@/components/feedback/loading-screen';

const PresalesRequestTypeListPage = lazy(() =>
  import('@pages/settings/accounts/presales-request-types/list').then((m) => ({
    default: m.PresalesRequestTypeListPage,
  }))
);

const PresalesRequestTypeCreatePage = lazy(() =>
  import('@pages/settings/accounts/presales-request-types/create').then((m) => ({
    default: m.PresalesRequestTypeCreatePage,
  }))
);

const PresalesRequestTypeEditPage = lazy(() =>
  import('@pages/settings/accounts/presales-request-types/edit').then((m) => ({
    default: m.PresalesRequestTypeEditPage,
  }))
);

export const presalesRequestTypesSettingsRoutes = [
  {
    path: 'presales-request-types',
    children: [
      {
        element: (
          <Suspense fallback={<LoadingScreen />}>
            <PresalesRequestTypeListPage />
          </Suspense>
        ),
        index: true,
      },
      {
        path: 'list',
        element: (
          <Suspense fallback={<LoadingScreen />}>
            <PresalesRequestTypeListPage />
          </Suspense>
        ),
      },
      {
        path: 'new',
        element: (
          <Suspense fallback={<LoadingScreen />}>
            <PresalesRequestTypeCreatePage />
          </Suspense>
        ),
      },
      {
        path: ':id/edit',
        element: (
          <Suspense fallback={<LoadingScreen />}>
            <PresalesRequestTypeEditPage />
          </Suspense>
        ),
      },
    ],
  },
];
